export default __webpack_public_path__ + "static/media/angers7.40fc0097.jpg";